// 公告数据配置
export const announcements = [
  {
    version: "v1.2.7",
    title: "增加部分工具",
    content: `
1、增加Burton数据看版，打通埋点以及项目数据
2、增加excle转换工具，用来快捷将sql 按天查询结果 转换为报表形式
3、增加按模板导出，模板包含指标匹配数据才行
4、🪿
    `,
    date: "2026-02-28",
  },
  {
    version: "v1.2.6",
    title: "优化全局体验",
    content: `
1、优化全局Loading加载体验，解决页面闪烁问题
2、新增应用初始化预加载机制，带超时保护
3、优化代码结构，提升应用启动性能
4、完善项目文档，新增多个技术文档
5、🪿
    `,
    date: "2026-02-28",
  },
  {
    version: "v1.2.5",
    title: "增加香奈儿C2B淘宝快捷转换",
    content: `
1、增加香奈儿C2B淘宝转换工具
2、优化了部分UI
3、🪿
    `,
    date: "2026-02-01",
  },
  {
    version: "v1.2.4",
    title: "增加云片短链生成",
    content: `
1、云片短链生成工具
2、优化token验证逻辑，防止过期未及时刷新
3、🪿
    `,
    date: "2026-01-23",
  },
  {
    version: "v1.2.3",
    title: "优化校验规则",
    content: `
1、dataworks sql查询过滤条件判断优化
2、🪿
    `,
    date: "2026-01-14",
  },
  {
    version: "v1.2.2",
    title: "优化使用体验",
    content: `
1、sql编辑窗口支持拖动调整展示区域
2、原始数据查询支持缓存上一次记录
3、🪿
    `,
    date: "2025-12-03",
  },
  {
    version: "v1.2.1",
    title: "增加两个内部工具",
    content: `
1、增加原始埋点数据查询
2、增加授权指南，暂时只有京东
3、🪿
    `,
    date: "2025-11-28",
  },
  {
    version: "v1.2.0",
    title: "提供1.2版本，优化UI，导航栏",
    content: `
1、优化UI
2、移除左侧导航栏，顶部导航栏支持返回首页，点击版本号即可
3、增加工具合集页面，将功能主要放在首页
4、🪿
    `,
    date: "2025-09-24",
  },
  {
    version: "v1.1.1",
    title: "Api管理模块增加接口调试功能，优化json响应展示",
    content: `
1、Api管理模块增加接口调试功能
2、优化接口调试json响应展示
3、优化appKey申请临时Token，json响应展示
4、🪿
    `,
    date: "2025-07-23",
  },
  {
    version: "v1.1.0",
    title: "增加登录模块相关",
    content: `
1、增加登录
2、增加路由守卫
3、移除旧的Appkey等。通过登录控制获取
4、🪿
    `,
    date: "2025-05-26",
  },
  {
    version: "v1.0.9",
    title: "增加转发Api模块",
    content: `
1、转发Api功能支持
2、appKey管理支持
3、支持一键复制请求参数、临时申请appKey请求Header
4、🪿
    `,
    date: "2025-05-22",
  },
  {
    version: "v1.0.8",
    title: "修复渠道流量导出SSE接口异常，重新实现UI，渠道路由合并",
    content: `
1、修复渠道流量导出SSE接口异常
2、重新实现UI
3、导出支持渠道可选
4、移除无用路由
5、🪿
    `,
    date: "2025-05-20",
  },
  {
    version: "v1.0.7",
    title: "增加周期任务配置模块",
    content: `
1、周期任务配置
2、支持多个任务类型配置
3、模板类型与模板列表打通
4、增加克隆功能，快速克隆大致参数相同的任务
    `,
    date: "2025-05-15",
  },
  {
    version: "v1.0.6",
    title: "增加合并报表、P2P文件互传等功能",
    content: `
1、自定义模板报表增加合并报表，支持多个日报合并推送处理
2、优化上次报表链接下载逻辑优化，单击复制链接到剪切板，双击快速下载报表
3、优化UI布局，增加不同分辨率的自适应显示
4、合并报表公告支持sheet的动态拖动调整顺序
5、增加P2P文件互传功能，支持文件互传，支持聊天室，只支持同一局域网内互传
6、增加公告栏，支持公告栏推送，支持公告栏历史记录查看
7、合并报表支持编辑功能
    `,
    date: "2025-05-10",
  },
  {
    version: "v1.0.5",
    title: "增加当日渠道流量查询",
    content: `
1、支持今日查：延迟15分钟
2、支持实时查询：延迟0-3分钟
    `,
    date: "2025-04-01",
  },
  {
    version: "v1.0.4",
    title: "增加当日模板转换工具",
    content: `
用来转换日报的模板报表：
1、支持模板下载
2、支持模板转换
    `,
    date: "2025-03-01",
  },
  {
    version: "v1.0.3",
    title: "增加淘宝短链转换",
    content: `
增加淘宝短链转换功能，支持批量转换
session联系阿伟获取
    `,
    date: "2025-03-01",
  },
  {
    version: "v1.0.2",
    title: "优化",
    content: `
增加了部分优化～～
    `,
    date: "2025-03-01",
  },
  {
    version: "v1.0.1",
    title: "增加渠道流量导出",
    content: `
增加渠道流量导出功能，支持按日期范围导出
    `,
    date: "2025-02-01",
  },
  {
    version: "v1.0.0",
    title: "欢迎使用模板报表推送",
    content: `
报表推送功能已上线，支持手动推送
    `,
    date: "2025-01-01",
  },
];
